// extracted by mini-css-extract-plugin
var _1 = "QmDxNvkVZCRC5yNkrAQm";
var _2 = "jmlfzlqlS_njyq5mBcf9";
var _3 = "nGK7iV5RbBxn7Y54Jwc7";
var _4 = "Xsi91_xshJkOUX6Tix0w";
var _5 = "EDdIasvzXssxVCRoXxVg";
var _6 = "qzndhNPRCifJ306UrglY";
export { _1 as "border", _2 as "icon", _3 as "iconHolder", _4 as "mainTitle", _5 as "page", _6 as "title" }
